var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center my-2",staticStyle:{"color":"#1f3d73"}},[_c('b-spinner',{staticClass:"align-middle",staticStyle:{"margin-right":"10px"}}),_c('strong',[_vm._v("Please Wait...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }